<template>
  <DTabs value="0" class="w-full">
    <DTabPanels class="p-0">
      <DTabPanel value="0">
        <SceneTree />
      </DTabPanel>
      <DTabPanel value="1">
        <CameraControls :canvasContainer="canvasContainer" />
      </DTabPanel>
    </DTabPanels>
  </DTabs>
</template>
<script setup>
import { CameraControls } from '@/components/layout';
import SceneTree from '@/components/layout/SceneTree.vue';
import { DTabPanel, DTabPanels, DTabs } from '@disguise/cloud-ui';

defineProps({
  canvasContainer: {
    type: Object,
    required: true,
  },
});
</script>
